import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';
import { IconType } from '@mutiny-pkg/dumpster-ui/icons';

export class MentionTypeaheadOption extends MenuOption {
  label: string;

  value: string;

  groupLabel: string;

  iconComponent?: IconType;

  completeness?: number;

  constructor(
    label: string,
    value: string,
    iconComponent?: IconType,
    completeness?: number,
    groupLabel: string = 'Other',
  ) {
    super(value);
    this.label = label;
    this.value = value;
    this.groupLabel = groupLabel;
    this.completeness = completeness;
    this.iconComponent = iconComponent;
  }
}
